export interface ComicChapter {
  number: number;
  title: string;
  date: string;
}

export interface Comic {
  id: string;
  title: string;
  cover: string;
  author: string;
  category: string;
  categorySlug: string;
  description: string;
  longDescription: string;
  chapters: ComicChapter[];
  rating: number;
  views: number;
  tags: string[];
  status: string;
  updatedAt: string;
  featured: boolean;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { name: '爱情', slug: 'romance', icon: 'ri-heart-line', description: '浪漫唯美的韩国爱情漫画，讲述动人情感故事' },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', description: '充满想象力的奇幻冒险，带你进入魔幻世界' },
  { name: '动作', slug: 'action', icon: 'ri-fire-line', description: '热血激情的动作漫画，拳拳到肉的战斗场面' },
  { name: '悬疑', slug: 'mystery', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑推理，层层递进的剧情设计' },
  { name: '喜剧', slug: 'comedy', icon: 'ri-emotion-laugh-line', description: '轻松搞笑的日常喜剧，让你会心一笑' },
  { name: '校园', slug: 'school', icon: 'ri-building-line', description: '青春洋溢的校园故事，记录美好的学生时代' },
  { name: '都市', slug: 'urban', icon: 'ri-building-2-line', description: '现代都市背景的精彩故事，贴近日常生活' },
  { name: '古风', slug: 'historical', icon: 'ri-ancient-gate-line', description: '古色古香的历史题材，展现传统东方美学' },
];

export const comics: Comic[] = [
  {
    id: 'secret-romance',
    title: '秘密恋情',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20romantic%20couple%20in%20soft%20warm%20lighting%2C%20elegant%20manhwa%20art%20with%20delicate%20linework%2C%20pastel%20color%20palette%2C%20emotional%20atmosphere%2C%20clean%20background%20with%20cherry%20blossom%20petals%2C%20professional%20digital%20art&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    author: '金智秀',
    category: '爱情',
    categorySlug: 'romance',
    description: '一段隐藏在日常生活中的秘密恋情，两个人在不经意间发现了彼此的心意。当办公室的冷漠上司与温暖下属之间擦出火花，他们能否打破职场规则？',
    longDescription: '在一家首尔顶尖广告公司，冷面上司朴志浩与新人员工李恩彩因为一个秘密项目被安排在了同一间办公室。起初两人互不相让，但随着工作的深入，彼此间的隔阂渐渐消融。然而公司规定严禁办公室恋情，他们必须在事业和爱情之间做出艰难选择。这是一部关于勇敢追爱的温馨浪漫故事，细腻描绘了现代职场中的人情冷暖与真挚情感。',
    chapters: [
      { number: 1, title: '新的开始', date: '2026-08-01' },
      { number: 2, title: '意外的相遇', date: '2026-08-01' },
      { number: 3, title: '渐生情愫', date: '2026-08-02' },
      { number: 4, title: '隐藏的心意', date: '2026-08-02' },
      { number: 5, title: '危机来临', date: '2026-08-03' },
      { number: 6, title: '告白', date: '2026-08-03' },
      { number: 7, title: '新的篇章', date: '2026-08-04' },
    ],
    rating: 4.8,
    views: 1250000,
    tags: ['爱情', '职场', '温馨', '职场恋爱'],
    status: '连载中',
    updatedAt: '2026-08-04',
    featured: true,
  },
  {
    id: 'magic-kingdom',
    title: '魔法王国',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20art%20of%20a%20magical%20kingdom%20with%20a%20heroine%20holding%20glowing%20magic%20staff%2C%20mystical%20atmosphere%20with%20floating%20crystals%2C%20ethereal%20lighting%2C%20manhwa%20art%20style%20with%20clean%20lines%2C%20purple%20and%20gold%20accents%2C%20dreamlike%20background&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    author: '朴志勋',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '一个普通高中生意外穿越到魔法王国，发现自己是预言中的救世主。在神秘力量的指引下，她踏上了拯救王国的冒险之旅。',
    longDescription: '十八岁的高中生韩素希原本过着平凡的生活，直到某天在图书馆发现了一本古老的魔法书。当她翻开书页的瞬间，一道光芒将她带到了艾瑟瑞亚魔法王国。在这个充满魔法与奇迹的世界里，她被告知自己就是传说中能够击退黑暗势力的光之魔法师。在王国王子亚瑟、精灵弓箭手艾琳和矮人战士索林的陪伴下，素希开始了寻找五大圣物的冒险。然而，黑暗势力也在暗中蠢蠢欲动，一场关乎两个世界命运的大战即将拉开序幕。',
    chapters: [
      { number: 1, title: '穿越之门', date: '2026-08-01' },
      { number: 2, title: '命运之书', date: '2026-08-01' },
      { number: 3, title: '魔法学院', date: '2026-08-02' },
      { number: 4, title: '森林试炼', date: '2026-08-02' },
      { number: 5, title: '黑暗觉醒', date: '2026-08-03' },
      { number: 6, title: '光之魔法', date: '2026-08-03' },
      { number: 7, title: '决战前夕', date: '2026-08-04' },
      { number: 8, title: '王国之战', date: '2026-08-04' },
    ],
    rating: 4.9,
    views: 2100000,
    tags: ['奇幻', '冒险', '魔法', '穿越'],
    status: '连载中',
    updatedAt: '2026-08-04',
    featured: true,
  },
  {
    id: 'shadow-agent',
    title: '暗影特工',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20scene%20of%20a%20cool%20male%20agent%20in%20black%20suit%20with%20sunglasses%20against%20night%20cityscape%2C%20neo-noir%20vibe%2C%20sharp%20manhwa%20art%20style%2C%20dramatic%20lighting%2C%20urban%20background%20with%20neon%20signs%2C%20professional%20illustration&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    author: '李俊昊',
    category: '动作',
    categorySlug: 'action',
    description: '前特种部队成员金泰浩隐退后成为私家侦探，却卷入了一场涉及国家机密的惊天阴谋，他必须用自己的方式守护正义。',
    longDescription: '曾经是韩国最精锐特种部队的王牌成员，金泰浩在一次任务后选择隐退，在首尔开设了一家小小的私家侦探事务所。原本以为余生将平淡度日，却因为一位神秘女子的委托，被卷入了一场涉及军方高层、跨国犯罪组织和国家机密的巨大阴谋。从繁华的首尔到偏僻的边境小镇，泰浩凭借过人的战斗技巧和敏锐的洞察力，一步步揭开真相。但当他发现幕后黑手竟然是自己曾经的战友时，一切变得更加复杂。',
    chapters: [
      { number: 1, title: '隐退之人', date: '2026-08-02' },
      { number: 2, title: '委托', date: '2026-08-02' },
      { number: 3, title: '追踪', date: '2026-08-03' },
      { number: 4, title: '伏击', date: '2026-08-03' },
      { number: 5, title: '真相', date: '2026-08-04' },
    ],
    rating: 4.7,
    views: 980000,
    tags: ['动作', '悬疑', '都市', '特工'],
    status: '连载中',
    updatedAt: '2026-08-04',
    featured: true,
  },
  {
    id: 'lost-memories',
    title: '遗失的记忆',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20mystery%20illustration%20of%20a%20woman%20looking%20into%20a%20broken%20mirror%20with%20puzzle%20pieces%20in%20the%20air%2C%20atmospheric%20manhwa%20art%2C%20moody%20blue-gray%20tones%2C%20suspenseful%20mood%2C%20clean%20art%20style%20with%20sharp%20contrast&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    author: '郑秀晶',
    category: '悬疑',
    categorySlug: 'mystery',
    description: '一觉醒来失去了三年记忆的女主角，发现自己身边的一切都变了。她必须通过零碎的线索拼凑出消失的三年里发生了什么。',
    longDescription: '28岁的神经科医生林秀雅在一个雨夜醒来，发现自己失去了过去三年的全部记忆。更令她惊恐的是，她的公寓变了，朋友们对她态度怪异，甚至同事们都用异样的眼光看她。日记本上最后三页被撕掉了，手机里存着大量加密文件，而所有的线索都指向了一个名字——徐道允，一个三年前失踪的连环杀手嫌疑人。秀雅必须在记忆和现实的交错中，找到真相。但当她越接近真相，就越发现，遗忘可能是一种自我保护，因为那段记忆太过可怕。',
    chapters: [
      { number: 1, title: '醒来', date: '2026-08-01' },
      { number: 2, title: '空白', date: '2026-08-01' },
      { number: 3, title: '碎片', date: '2026-08-02' },
      { number: 4, title: '阴影', date: '2026-08-02' },
      { number: 5, title: '追踪', date: '2026-08-03' },
      { number: 6, title: '揭晓', date: '2026-08-04' },
    ],
    rating: 4.6,
    views: 870000,
    tags: ['悬疑', '心理', '推理', '失忆'],
    status: '连载中',
    updatedAt: '2026-08-04',
    featured: false,
  },
  {
    id: 'daily-laugh',
    title: '搞笑日常',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20comedy%20style%20illustration%20of%20funny%20office%20workers%20making%20exaggerated%20faces%2C%20chibi%20art%20style%2C%20bright%20colorful%20palette%2C%20humorous%20manhwa%20with%20cartoonish%20expressions%2C%20simple%20white%20background%2C%20comic%20speech%20bubbles&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    author: '崔民秀',
    category: '喜剧',
    categorySlug: 'comedy',
    description: '四个性格迥异的职场新人在同一家公司里的搞笑日常，从面试到入职，笑料百出。每一集都让人捧腹大笑。',
    longDescription: '菜鸟四人组的职场生存记！完美主义者朴组长、天然呆咸美英、毒舌王金道俊和社恐张敏瑞，四个性格完全不同的年轻人阴差阳错进入了同一家游戏公司。从入职第一天起，他们就在各种意想不到的乌龙事件中摸爬滚打——把咖啡洒在CEO身上、用投影仪看综艺被全公司围观、公司团建变成丛林求生……每一段经历都荒诞又真实，让每一个职场人都能从中找到自己的影子，在爆笑之余感受到温暖和感动。',
    chapters: [
      { number: 1, title: '入职第一天', date: '2026-08-01' },
      { number: 2, title: '咖啡灾难', date: '2026-08-01' },
      { number: 3, title: '团建噩梦', date: '2026-08-02' },
      { number: 4, title: '加班夜话', date: '2026-08-02' },
      { number: 5, title: '年会风云', date: '2026-08-03' },
      { number: 6, title: '升职大战', date: '2026-08-04' },
    ],
    rating: 4.5,
    views: 1500000,
    tags: ['喜剧', '职场', '日常', '搞笑'],
    status: '连载中',
    updatedAt: '2026-08-04',
    featured: true,
  },
  {
    id: 'campus-spring',
    title: '校园之春',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20school%20life%20illustration%20of%20two%20students%20under%20cherry%20blossom%20trees%20in%20spring%2C%20warm%20sunlight%2C%20soft%20pastel%20colors%2C%20youthful%20romance%20mood%2C%20clean%20manhwa%20art%20style%2C%20dreamy%20spring%20atmosphere&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    author: '南宝拉',
    category: '校园',
    categorySlug: 'school',
    description: '高中二年级的春天，转学生韩智浩的到来打破了班级原有的平静。一个关于青春、友谊与成长的故事就此展开。',
    longDescription: '高二那年春天，因为父母工作调动，韩智浩转学到了首尔的一所重点高中。原本只想安静度过高中生活的他，却因为出众的外貌和温柔的性格迅速成为了校园焦点。班长金多美对他一见钟情、学霸李敏赫视他为竞争对手、神秘的艺术生郑世雅似乎知道他的秘密……在这个充满青春气息的校园里，每个人都有自己的故事。友情、暗恋、考试压力、社团活动，共同编织成一幅灿烂的青春画卷。',
    chapters: [
      { number: 1, title: '转学生', date: '2026-08-02' },
      { number: 2, title: '第一堂课', date: '2026-08-02' },
      { number: 3, title: '社团招新', date: '2026-08-03' },
      { number: 4, title: '运动会', date: '2026-08-03' },
      { number: 5, title: '文化节', date: '2026-08-04' },
    ],
    rating: 4.7,
    views: 1100000,
    tags: ['校园', '青春', '恋爱', '成长'],
    status: '连载中',
    updatedAt: '2026-08-04',
    featured: false,
  },
  {
    id: 'city-lights',
    title: '城市之光',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20urban%20drama%20illustration%20of%20a%20young%20professional%20woman%20on%20a%20rooftop%20overlooking%20Seoul%20cityscape%20at%20night%2C%20sophisticated%20manhwa%20art%2C%20warm%20city%20lights%2C%20modern%20lifestyle%20aesthetic%2C%20contemplative%20mood&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    author: '张贤宇',
    category: '都市',
    categorySlug: 'urban',
    description: '在大城市打拼的年轻人们，各自怀揣梦想，在繁华都市中寻找属于自己的那束光。一部温暖治愈的都市情感漫画。',
    longDescription: '在首尔的钢筋森林中，五个来自不同背景的年轻人因缘际会成为了邻居。有梦想成为顶级主厨却只能在便利店打工的朴志敏，有放弃了稳定公务员工作追求音乐梦想的街头艺人金泰亨，有独自从釜山来首尔创业的咖啡店老板姜素拉，有在投行工作却渴望简单生活的精英尹智勋，以及从中国来韩国留学的交换生林念念。他们在清溪川边分享心事，在便利店深夜长谈，在彼此的生命中成为温暖的存在。这座城市很大，但有彼此，就不孤单。',
    chapters: [
      { number: 1, title: '新邻居', date: '2026-08-01' },
      { number: 2, title: '深夜便利店', date: '2026-08-02' },
      { number: 3, title: '梦想的重量', date: '2026-08-02' },
      { number: 4, title: '清溪川的约定', date: '2026-08-03' },
      { number: 5, title: '十字路口', date: '2026-08-04' },
    ],
    rating: 4.6,
    views: 760000,
    tags: ['都市', '治愈', '梦想', '友情'],
    status: '连载中',
    updatedAt: '2026-08-04',
    featured: false,
  },
  {
    id: 'palace-secrets',
    title: '宫阙秘史',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20historical%20illustration%20of%20a%20beautiful%20woman%20in%20traditional%20Korean%20hanbok%20in%20ancient%20palace%20courtyard%2C%20elegant%20manhwa%20art%20style%2C%20warm%20amber%20tones%2C%20historical%20Joseon%20era%20aesthetic%2C%20flowing%20fabric%2C%20autumn%20leaves&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    author: '韩艺瑟',
    category: '古风',
    categorySlug: 'historical',
    description: '朝鲜王朝时期，一个聪明伶俐的宫女凭借智慧在复杂的宫廷斗争中求生存，揭开了一段被尘封的宫廷秘史。',
    longDescription: '朝鲜英祖年间，平民出身的少女崔秀珍因缘际会进入宫中成为宫女。她天资聪颖，很快从一众宫女中脱颖而出，被安排到了王妃身边侍奉。然而宫廷远比她想象的复杂——权力斗争、后宫倾轧、世子之争，每一件事都可能要了她的命。在这个过程中，秀珍意外得知了自己身世的秘密，原来她与王室有着千丝万缕的联系。为了保护自己和珍视的人，她必须学会在暗流涌动的宫廷中游刃有余。',
    chapters: [
      { number: 1, title: '入宫', date: '2026-08-01' },
      { number: 2, title: '宫女试炼', date: '2026-08-02' },
      { number: 3, title: '王妃的秘密', date: '2026-08-02' },
      { number: 4, title: '宫廷宴会', date: '2026-08-03' },
      { number: 5, title: '真相浮现', date: '2026-08-04' },
    ],
    rating: 4.8,
    views: 1350000,
    tags: ['古风', '历史', '宫廷', '权谋'],
    status: '连载中',
    updatedAt: '2026-08-04',
    featured: true,
  },
  {
    id: 'blood-moon',
    title: '血月传说',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20dark%20fantasy%20illustration%20of%20a%20warrior%20under%20blood%20red%20moon%20with%20sword%2C%20gothic%20manhwa%20art%20style%2C%20dramatic%20red%20and%20black%20color%20scheme%2C%20mysterious%20atmosphere%2C%20full%20moon%20in%20background%2C%20intense%20mood&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    author: '尹泰民',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '在血月之夜出生的少年尹浩，拥有与恶魔沟通的能力。当黑暗势力即将吞噬世界时，他成为了人类最后的希望。',
    longDescription: '古老的预言说，当血月降临，被选中的孩子将降生，他将拥有对抗黑暗的力量。尹浩就是这样一位被选中者。在十六岁生日那天，他第一次看见了这个世界的另一面——潜伏在人群中的恶魔、隐藏在阴影中的猎魔人、以及那个在血月之夜与他命运相连的神秘女孩。在猎魔人师父的训练下，尹浩开始学习使用自己的力量。但随着力量的增长，他的身体也逐渐被黑暗侵蚀。是成为拯救世界的英雄，还是变成自己曾经对抗的怪物？',
    chapters: [
      { number: 1, title: '血月之夜', date: '2026-08-02' },
      { number: 2, title: '觉醒', date: '2026-08-02' },
      { number: 3, title: '猎魔人', date: '2026-08-03' },
      { number: 4, title: '深渊', date: '2026-08-03' },
      { number: 5, title: '抉择', date: '2026-08-04' },
    ],
    rating: 4.9,
    views: 1850000,
    tags: ['奇幻', '黑暗', '冒险', '战斗'],
    status: '连载中',
    updatedAt: '2026-08-04',
    featured: true,
  },
  {
    id: 'love-recipe',
    title: '恋爱食谱',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romantic%20cooking%20illustration%20of%20a%20couple%20cooking%20together%20in%20a%20warm%20kitchen%2C%20soft%20lighting%2C%20cozy%20atmosphere%2C%20food-themed%20manhwa%20art%2C%20pastel%20colors%2C%20romantic%20mood%2C%20ingredients%20on%20table&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    author: '柳真',
    category: '爱情',
    categorySlug: 'romance',
    description: '不善言辞的米其林大厨和活泼开朗的美食博主，因一道家常菜谱结缘。用美食温暖彼此的治愈系爱情故事。',
    longDescription: '张宇辰是首尔最年轻的米其林一星主厨，他以精湛的厨艺和冷峻的外表闻名。但他的餐厅从来不接受美食博主的预约。直到有一天，美食博主韩彩英用奶奶的祖传泡菜食谱打动了他。两人从厨房开始的故事，逐渐发酵成了比泡菜更醇厚的情感。彩英用镜头记录下宇辰的每一道菜品，也悄悄记录下他冰山外表下的温柔。当美食与爱情相遇，每一道菜都成了他们之间的秘密语言。',
    chapters: [
      { number: 1, title: '泡菜对决', date: '2026-08-01' },
      { number: 2, title: '厨房笔记', date: '2026-08-02' },
      { number: 3, title: '米其林之约', date: '2026-08-02' },
      { number: 4, title: '奶奶的味道', date: '2026-08-03' },
      { number: 5, title: '甜点告白', date: '2026-08-03' },
      { number: 6, title: '爱的食谱', date: '2026-08-04' },
    ],
    rating: 4.7,
    views: 920000,
    tags: ['爱情', '美食', '治愈', '温馨'],
    status: '连载中',
    updatedAt: '2026-08-04',
    featured: false,
  },
  {
    id: 'neon-blade',
    title: '霓虹之刃',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cyberpunk%20action%20illustration%20of%20a%20female%20fighter%20with%20neon%20katana%20in%20futuristic%20night%20city%2C%20cyberpunk%20manhwa%20art%2C%20neon%20pink%20and%20cyan%20accents%2C%20dynamic%20pose%2C%20rainy%20street%2C%20holographic%20advertisements&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    author: '姜东元',
    category: '动作',
    categorySlug: 'action',
    description: '2045年的首尔，赛博朋克世界中的一位神秘女剑客，用手中的霓虹之刃对抗控制城市的巨型企业。',
    longDescription: '2045年，首尔已经变成了一座赛博朋克城市。巨型企业韩光集团掌控着城市的一切——从空气净化到数据隐私。底层民众在霓虹灯照不到的角落艰难求生。在这种环境下，一个被称为"霓虹之刃"的神秘剑客出现了。她手持一把能斩断数据的离子刃，专门攻击韩光集团的违法设施。前刑警朴泰俊在追查霓虹之刃的过程中，逐渐发现了韩光集团背后骇人听闻的秘密——他们正在利用民众的大脑数据建立一个精神控制网络。面对共同的敌人，泰俊必须做出选择：继续追捕霓虹之刃，还是与她并肩作战。',
    chapters: [
      { number: 1, title: '霓虹之影', date: '2026-08-01' },
      { number: 2, title: '追捕者', date: '2026-08-02' },
      { number: 3, title: '地下世界', date: '2026-08-02' },
      { number: 4, title: '真相之门', date: '2026-08-03' },
      { number: 5, title: '同盟', date: '2026-08-03' },
      { number: 6, title: '决战韩光', date: '2026-08-04' },
    ],
    rating: 4.5,
    views: 680000,
    tags: ['动作', '科幻', '赛博朋克', '战斗'],
    status: '连载中',
    updatedAt: '2026-08-04',
    featured: false,
  },
  {
    id: 'flower-diary',
    title: '花语日记',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20beautiful%20illustration%20of%20a%20girl%20in%20a%20flower%20shop%20surrounded%20by%20colorful%20bouquets%2C%20soft%20morning%20sunlight%2C%20healing%20manhwa%20art%20style%2C%20gentle%20pastel%20colors%2C%20floral%20aesthetic%2C%20peaceful%20atmosphere&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    author: '文佳瑛',
    category: '都市',
    categorySlug: 'urban',
    description: '花店少女尹荷娜通过花语帮助人们传达心意，每一束花背后都有一个温暖人心的故事。一部治愈心灵的漫画。',
    longDescription: '在首尔弘大附近的一条安静小巷里，有一家名叫"花语日记"的小小花店。店主是23岁的尹荷娜，她不仅擅长插花，还有一个特别的才能——她似乎能感知到花朵想要传达的情感。每当有客人来买花，她都能帮他们选出最适合表达心意的那一束。暗恋却不敢表白的少年、想要和女儿和解的母亲、思念已故妻子的老人……每一位客人都带着自己的故事走进花店，带着希望和温暖离开。在这间小小的花店里，花朵不只是花朵，它们是爱的信使，是治愈的力量。',
    chapters: [
      { number: 1, title: '花店少女', date: '2026-08-01' },
      { number: 2, title: '第一束花', date: '2026-08-01' },
      { number: 3, title: '妈妈的花', date: '2026-08-02' },
      { number: 4, title: '青春的暗香', date: '2026-08-03' },
      { number: 5, title: '永恒的约定', date: '2026-08-04' },
    ],
    rating: 4.8,
    views: 1050000,
    tags: ['都市', '治愈', '温馨', '花语'],
    status: '连载中',
    updatedAt: '2026-08-04',
    featured: false,
  },
];

export function getComicsByCategory(slug: string): Comic[] {
  return comics.filter((c) => c.categorySlug === slug);
}

export function getComicById(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getFeaturedComics(): Comic[] {
  return comics.filter((c) => c.featured);
}

export function getLatestUpdates(limit: number = 6): Comic[] {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
}

export function getPopularComics(limit: number = 6): Comic[] {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
}

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((c) => c.slug === slug);
}